import { Box, Stack } from '@mui/material';
import Logo from '@raas/shared/src/components/minimals/logo';
import { NavSectionMini } from '@raas/shared/src/components/minimals/nav-section';
import LegalProvisionContext from '@raas/shared/src/contexts/LegalProvisionContext';
import { NAV } from '@raas/shared/src/shared-config-global';
import { hideScrollbarX } from '@raas/shared/src/utils/cssStyles';
import { useContext } from 'react';
import NavToggleButton from './NavToggleButton';
import getNavConfig from './config-navigation';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { legalProvisionContext } = useContext(LegalProvisionContext);
  const hasTranslations = legalProvisionContext?.translations?.length > 1;
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini
          data={getNavConfig({ hasVersion: !!legalProvisionContext, hasTranslations })}
        />
      </Stack>
    </Box>
  );
}
